var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecentFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7951_13564",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.52739 1.58766C4.68036 1.57516 4.86189 1.57518 5.05263 1.5752H11.7982L15.7999 5.77707L15.7999 14.5725C15.8 14.7633 15.8 14.9448 15.7875 15.0978C15.7739 15.2646 15.7421 15.4559 15.6446 15.6471C15.508 15.9153 15.29 16.1333 15.0219 16.2699C14.8307 16.3673 14.6393 16.3991 14.4725 16.4127C14.3196 16.4252 14.138 16.4252 13.9473 16.4252H5.05259C4.86187 16.4252 4.68035 16.4252 4.52739 16.4127C4.36058 16.3991 4.16925 16.3673 3.97802 16.2699C3.70989 16.1333 3.49189 15.9153 3.35527 15.6471C3.25783 15.4559 3.22604 15.2646 3.21241 15.0978C3.19991 14.9448 3.19993 14.7633 3.19995 14.5725V3.42788C3.19993 3.23714 3.19991 3.0556 3.21241 2.90263C3.22604 2.73582 3.25783 2.54449 3.35527 2.35326C3.49189 2.08513 3.70989 1.86713 3.97802 1.73051C4.16925 1.63307 4.36058 1.60129 4.52739 1.58766ZM4.54994 3.00005C4.54994 2.95863 4.58352 2.92505 4.62494 2.92505H10.3249V6.67534H14.4499V15C14.4499 15.0415 14.4164 15.075 14.3749 15.075H4.62494C4.58352 15.075 4.54994 15.0415 4.54994 15V3.00005ZM11.6749 5.32534V3.40317L13.5056 5.32534H11.6749Z",
    fill: "#1B1C1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87497 11.4755H6.12497V10.1255H9.87497V11.4755Z",
    fill: "#1B1C1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12497 13.7255H9.87497V12.3755H6.12497V13.7255Z",
    fill: "#1B1C1E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7951_13564)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 18,
    height: 18,
    fill: "#878A93"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentFile);
export default __webpack_public_path__ + "static/media/recentFile.0dc7bd15fee7022683df1c80e9c055f0.svg";
export { ForwardRef as ReactComponent };